module.exports = __webpack_public_path__ + "img/mob-side-arrow.20317f67.svg";